const ITEMS = [
  "Bursa Malaysia",
  "SGX Mainboard",
  "Forex & Comex",
  "Nasdaq & HSI",
  "Syariah Compliant Signals",
  "Institutional Precision",
  "Real-Time WhatsApp Alerts",
  "VIP Account Handling",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-line bg-surface/60 py-6">
      <div className="animate-marquee flex w-max items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span
              className={`whitespace-nowrap font-display text-3xl font-extrabold uppercase tracking-tight md:text-4xl ${
                i % 2 === 0 ? "text-slate-200" : "text-outline"
              }`}
            >
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-gold" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
